import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  faChevronDown,
  faChevronUp,
  faSquareCheck,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Row, theme, Typography } from 'antd';

import './AssetCapabilitiesList.css';

export const AssetCapabilitiesList = ({ skills }: { skills: string[] }) => {
  const [showList, setShowList] = useState(false);
  const { token } = theme.useToken();
  const { t } = useTranslation();

  const hasManySkills = skills.length > 4;

  return (
    <>
      {skills.map((skill: string) => (
        <Row
          key={skill}
          align="top"
          gutter={token.marginXS}
          style={{ flexFlow: 'row' }}
          className={`asset-capabilities-row ${showList && 'asset-capabilities-row--revealed'}`}
          data-testid="capabilities-row"
        >
          <Col>
            <FontAwesomeIcon icon={faSquareCheck} />
          </Col>
          <Col>
            <Typography.Text>{skill}</Typography.Text>
          </Col>
        </Row>
      ))}
      {hasManySkills && (
        <Row style={{ marginTop: token.marginXS }}>
          <Button
            icon={
              <FontAwesomeIcon icon={showList ? faChevronUp : faChevronDown} />
            }
            onClick={() => setShowList(!showList)}
            size="small"
            style={{ marginBottom: token.marginXS }}
          >
            {showList
              ? t('common.buttons.showLess')
              : t('common.buttons.showMore')}
          </Button>
        </Row>
      )}
    </>
  );
};
